var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sm:flex justify-between items-center"},[_c('div',{staticClass:"text-[28px] font-bold text-[#091E42]"},[_vm._v(" "+_vm._s(_vm.$route.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }